export default __webpack_public_path__ + "static/media/circle.2c7d9d83.svg";